import * as React from 'react';
import { BatchUploadStats, FileUploadItem } from './types';
import { getUploadProgressSummary } from './upload-utils';
import { UploadProgressItem } from './upload-progress-item';
import * as S from './upload-progress.styles';

export interface UploadProgressListProps {
    items: FileUploadItem[];
    stats: BatchUploadStats;
    isUploading: boolean;
}

export const UploadProgressList: React.FC<UploadProgressListProps> = ({
    items,
    stats,
    isUploading,
}) => {
    const { title, subtitle } = getUploadProgressSummary(stats, isUploading);

    return (
        <S.ListContainer>
            <S.ListHeader>
                <S.ListTitle>{title}</S.ListTitle>
                {subtitle && <S.ListSubtitle>{subtitle}</S.ListSubtitle>}
            </S.ListHeader>

            <S.ItemList>
                {items.map(item => (
                    <UploadProgressItem key={item.id} item={item} />
                ))}
            </S.ItemList>
        </S.ListContainer>
    );
};
